import React, { Component } from "react";
import P5Wrapper from "react-p5-wrapper";
import sketch from "./sketch";

class PlanetsPage extends Component {
  render() {
    return <P5Wrapper sketch={sketch} history={this.props.history} />;
  }
}

export default PlanetsPage;



// WEBPACK FOOTER //
// ./src/containers/PlanetsPage/index.js